export default __webpack_public_path__ + "static/media/Marel.39495b01.png";